import styled from '@emotion/styled';
import { colors, Button } from '../../plushcare-components';
import { Form } from '../../forms';
import { BookingFlowMasterWrapper } from '../../../components/bookingFlow/BookingLayout/BookingFlowMasterWrapper.tsx';

export const TriageContainer = styled.div`
  width: 100%;
`;

export const MainContent = styled(BookingFlowMasterWrapper)`
  margin: 10px 0 50px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  height: 100%;
  color: ${props => props.theme.colors.foreground};

  h1 {
    font-size: 24px;
    color: ${props => props.theme.colors.foreground};
  }

  @media (min-width: 768px) {
    margin: 30px auto;
  }
`;

export const RadioForm = styled(Form)`
  width: 100%;
  margin-top: 20px;

  div {
    margin-bottom: 10px;
  }
`;
export const BMIForm = styled(Form)`
  width: 100%;
  margin-top: 0;

  div {
    margin-bottom: 10px;
  }
`;

export const NoBackContainer = styled(MainContent)`
  margin: 30px 50px 0;
  justify-content: space-between;

  h2 {
    font-size: 24px;
    color: ${colors.white};
  }

  @media (min-width: 768px) {
    max-width: 400px;
    margin: 30px auto;
    justify-content: flex-start;
  }
`;

export const ResultsContent = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin: 40px 50px;

  color: ${props => props.theme.colors.foreground};

  h1 {
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;
    color: ${props => props.theme.colors.foreground};
    margin: 0;
  }

  h2 {
    font-size: 24px;
    font-weight: 400;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
  }

  a {
    margin-top: 35px;
  }

  .section-container {
    margin: 30px 0 45px;
  }

  @media (min-width: 768px) {
    max-width: 400px;
    margin: 30px auto;
  }
`;

export const CheckboxForm = styled(Form)`
  margin-bottom: 30px;

  p {
    margin-top: 16px;
    border-bottom: 1px solid ${colors.rain};
   }

  .triage-check {
    border-bottom: 1px solid ${colors.rain};
  }

  button {
    width: 100%;
    margin: 36px auto;
  }
`;

export const BackBtnStyled = styled.div`
  button {
    background: none;
    left: -22px;
    border: none;
    position: relative;
    width: fit-content;
    // this is for iOS Safari button default style
    font-size: 6px;
    &:focus {
      outline: none;
    }
  }

  span {
    font-size: 14px;
    line-height: 15px;
    color: ${colors.adaRoyalBlue};
    font-weight: 500;
    position: relative;
    top: -17px;
    left: -25px;
  }
`;

export const ConditionContainer = styled.div`
  span {
    text-transform: capitalize;
  }
`;

// important needed as Button was overriding these by stronger rule
export const ContinueButton = styled(Button)`
  font-size:20px!important;
  font-weight: 600!important;
  width: 100%;
`;
